(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function initSlides(root) {
    if (root.dataset.hmReady) return;
    root.dataset.hmReady = "1";
    const track = $("[data-hm-slides-track]", root);
    const slides = Array.from(track.children);
    const dots = $$("[data-hm-slides-dots] button", root);
    if (slides.length < 2) return;
    let index = 0, timer = null;
    const go = i => {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: "smooth" });
    };
    const sync = () => {
      const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      index = Math.min(slides.length - 1, Math.max(0, i));
      dots.forEach((d, k) => { if (k === index) d.setAttribute("aria-current", "true"); else d.removeAttribute("aria-current"); });
    };
    let raf = 0;
    track.addEventListener("scroll", () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    dots.forEach((d, k) => d.addEventListener("click", () => { stop(); go(k); }));
    const prev = $("[data-hm-slides-prev]", root), next = $("[data-hm-slides-next]", root);
    if (prev) prev.addEventListener("click", () => { stop(); go(index - 1); });
    if (next) next.addEventListener("click", () => { stop(); go(index + 1); });
    track.addEventListener("keydown", e => {
      if (e.key === "ArrowRight") { e.preventDefault(); stop(); go(index + 1); }
      if (e.key === "ArrowLeft") { e.preventDefault(); stop(); go(index - 1); }
    });
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => {
      if (reduce || root.dataset.autoplay !== "true" || timer) return;
      timer = setInterval(() => go(index + 1), (Number(root.dataset.speed) || 5) * 1000);
    };
    root.addEventListener("pointerenter", stop);
    root.addEventListener("pointerleave", start);
    root.addEventListener("focusin", stop);
    track.addEventListener("touchstart", stop, { passive: true });
    document.addEventListener("visibilitychange", () => (document.hidden ? stop() : start()));
    start();
  }

  function currentVariantId(el) {
    const scope = el.closest(".shopify-section") || document;
    const input = $("form input[name=\"id\"]", scope);
    return input && input.value;
  }

  function updateWhatsApp(a) {
    let variants = [];
    try { variants = JSON.parse($("[data-hm-wa-variants]", a.parentElement).textContent); } catch (e) { return; }
    const id = currentVariantId(a);
    const v = variants.find(x => String(x.id) === String(id)) || variants[0];
    if (!v) return;
    const single = variants.length === 1 && v.title === "Default Title";
    const intro = v.available ? a.dataset.msg : a.dataset.msgSoldout;
    const msg = [intro, a.dataset.title + (single ? "" : " (" + v.title + ")") + " – " + v.price, a.dataset.url + "?variant=" + v.id].join("\n");
    a.href = "https://wa.me/" + a.dataset.number + "?text=" + encodeURIComponent(msg);
    const label = $("[data-hm-wa-label]", a);
    if (label) label.textContent = v.available ? a.dataset.label : a.dataset.labelSoldout;
  }

  document.addEventListener("click", e => {
    const a = e.target.closest("[data-hm-wa]");
    if (a) updateWhatsApp(a);
  }, true);
  document.addEventListener("change", e => {
    if (!e.target.closest("variant-picker")) return;
    setTimeout(() => $$("[data-hm-wa]").forEach(updateWhatsApp), 600);
  });

  function initVideos(root) {
    const vids = $$('[data-hm-reel]', root);
    if (!vids.length) return;
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const load = v => {
      if (v.dataset.loaded) return;
      $$('source[data-src]', v).forEach(s => { s.src = s.dataset.src; });
      v.dataset.loaded = '1';
      v.load();
    };
    const setSound = (v, on) => {
      v.muted = !on;
      const btn = $('[data-hm-reel-sound]', v.closest('.hm-reel'));
      if (btn) {
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.setAttribute('aria-label', btn.getAttribute('aria-label').replace(/^(Unmute|Mute)/, on ? 'Mute' : 'Unmute'));
      }
    };

    if ('IntersectionObserver' in window) {
      const nearIO = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { load(e.target); nearIO.unobserve(e.target); } }), { rootMargin: '300px 300px' });
      const playIO = new IntersectionObserver(es => es.forEach(e => {
        const v = e.target;
        if (e.isIntersecting && e.intersectionRatio >= 0.5) {
          load(v);
          if (!reduce || v.dataset.userPlay) v.play().catch(() => {});
        } else if (!document.fullscreenElement) {
          v.pause();
          if (!v.muted) setSound(v, false);
        }
      }), { threshold: [0, 0.5] });
      vids.forEach(v => { nearIO.observe(v); playIO.observe(v); });
    } else {
      vids.forEach(load);
    }

    root.addEventListener('click', e => {
      const card = e.target.closest('.hm-reel');
      if (!card) return;
      const v = $('[data-hm-reel]', card);
      load(v);
      v.dataset.userPlay = '1';
      if (e.target.closest('[data-hm-reel-fs]')) {
        vids.forEach(o => { if (o !== v) setSound(o, false); });
        setSound(v, true);
        v.controls = true;
        v.play().catch(() => {});
        if (v.requestFullscreen) v.requestFullscreen().catch(() => {});
        else if (v.webkitEnterFullscreen) v.webkitEnterFullscreen();
        return;
      }
      const turnOn = v.muted;
      vids.forEach(o => { if (o !== v) setSound(o, false); });
      setSound(v, turnOn);
      v.play().catch(() => { setSound(v, false); v.play().catch(() => {}); });
    });

    const exitFs = () => { if (!document.fullscreenElement) vids.forEach(v => { v.controls = false; }); };
    document.addEventListener('fullscreenchange', exitFs);
    vids.forEach(v => v.addEventListener('webkitendfullscreen', () => { v.controls = false; }));
  }


  const init = () => {
    $$("[data-hm-slides]").forEach(initSlides);
    $$("[data-hm-videos]").forEach(root => { if (!root.dataset.hmReady) { root.dataset.hmReady = "1"; initVideos(root); } });
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", init);
})();
